import { Component, ElementRef, Input, Output, OnInit, ViewChild, OnChanges, EventEmitter } from '@angular/core';
import { StateService, trace } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from "../../services/data.service";
import { OnClickEvent, OnRatingChangeEven, OnHoverRatingChangeEvent } from "angular-star-rating/star-rating-struct";
import { LogService } from '../../services/log.service';
// import { Z_UNKNOWN } from 'zlib';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent implements OnInit {

  currency = [];
  searchCurrency = "";
  modalRef: NgbModalRef;
  closeResult: any;
  reviewForm = {};
  loading: boolean = false;

  @Input() productDetail;
  @Input() index;

  @Output() ratingDone = new EventEmitter();
  @Output() reviewContent = new EventEmitter();

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private dataService: DataService,
    private logService: LogService
  ) { }

  @ViewChild("reviewModalContent") private reviewModalContent: ElementRef;

  ngOnInit() {
    this.currency = this.dataService.currencyList;
  }

  ngOnChanges() {
    this.reviewForm['transaction_id'] = this.productDetail.transaction_id;
    this.reviewForm['ean'] = this.productDetail.ean;
    this.reviewForm['response_type'] = this.productDetail.response_type;
  }

  private filterCurrency = () => {
    setTimeout(() => {
      this.logService.printLog("Searched country - ", this.searchCurrency);
      this.logService.printLog("Countries filtered list - ", this.currency);
      if (this.searchCurrency !== "") {
        this.currency = this.dataService.currencyList.filter(currency =>
          currency.name.toLowerCase().startsWith(this.searchCurrency.toLowerCase())
        );
      } else {
        this.currency = this.dataService.currencyList;
      }
    }, 200);
  };

  ratingUser() {
    this.reviewForm['country'] = this.dataService.selectedCountryName;
    this.reviewForm['user_id'] = this.dataService.userDetails['user_id'];
    if (this.productDetail['response_type'] === 'Unknown' || this.productDetail['response_type'] == "Uknown") {
      this.logService.printLog('First condition works....', '');
      this.loading = true;
      this.reviewForm['rating'] = 0.0;
      this.apiService.userCreatedProduct(this.reviewForm, (response) => {
        this.loading = false;
        this.logService.printLog("create product", response);
        if (response.created === true) {
          this.logService.printLog('Product Created Successfully..', '');          
          if(!this.reviewForm.hasOwnProperty('comment')) {
            this.reviewForm['comment'] = '';
          }
          if(!this.reviewForm.hasOwnProperty('product_name')) {
            this.reviewForm['product_name'] = '';
          }
          if(!this.reviewForm.hasOwnProperty('price')) {
            this.reviewForm['price'] = '';
          }
          if(!this.reviewForm.hasOwnProperty('shop')) {
            this.reviewForm['shop'] = '';
          }
          if(!this.reviewForm.hasOwnProperty('town')) {
            this.reviewForm['town'] = '';
          }
          if(!this.reviewForm.hasOwnProperty('countryName')) {
            this.reviewForm['countryName'] = '';
          }
          this.loading = true;
          this.apiService.userRating(this.reviewForm, (response) => {
            this.loading = false;
            this.logService.printLog("submit form", this.reviewForm);
            this.logService.printLog("review rating", response);

            if (response.response === "ok") {
              this.logService.printLog('response ok', '');
              let reviewData = {
                index: this.index,
                response: this.reviewForm
              }
              this.reviewContent.emit(reviewData);
              this.frontEndService.addToast('Success', response['message'], 'success');
              this.reviewForm = {};
            } else {
              this.logService.printLog("response not ok ", "");
              this.frontEndService.addToast('Error', response['message'], 'error');
            }
          });
        } else {
          this.frontEndService.addToast('Error', "This product is not created", 'error');
          this.logService.printLog('Error....', "");
        }
      });
    } else {
      this.frontEndService.addToast('Error', "This product is not created", 'error');
      this.logService.printLog('Error', '');
    }
    this.closeModal();
  }

  closeModal() {
    // this.reviewForm = {};
    this.modalRef.close();
  }

  open() {
    if (localStorage.getItem('user') !== null) {
      this.modalRef = this.modalService.open(this.reviewModalContent);
      // this.logService.printLog("Right modal opened");
      this.modalRef.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } else {
      this.frontEndService.confirmAlert("Title", 'Please login first', 'question', (response) => {
        this.logService.printLog("confirmAlert response", response);
        if (response.value) {

        }
      });
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onClick = ($event: OnClickEvent) => {
    // this.logService.printLog('onClick $event: ', $event);
    this.reviewForm['rating'] = $event.rating;
  };

  sendData(code, transaction_id, response_type) {
    this.dataService.productResponse['transaction_id'] = transaction_id;
    this.dataService.productForm['ean'] = code;
    this.dataService.productResponse['response_type'] = response_type;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/reviews/reviews.component.ts